import type { AnchorHTMLAttributes } from 'react';
import { Link, type LinkProps } from 'react-router-dom';
import styled from 'styled-components';

import { createShouldForwardStyledProp } from '../../../styles';
import { Icon } from '../../Icons';
import { buttonStyle, type ButtonProps } from '../styles';

type NavButtonPropsBase = Omit<
  ButtonProps<AnchorHTMLAttributes<HTMLAnchorElement>>,
  'done' | 'loading' | 'prefix' | 'suffix'
>;
type NavButtonWrapperProps = Omit<NavButtonPropsBase, 'endIcon' | 'startIcon'>;

// styled(Link) forwards props through a custom component, so filter the
// style-only props consumed by buttonStyle before they reach Link/the DOM.
const nonForwardedProps = new Set([
  'dim',
  'disabled',
  'flex',
  'ghost',
  'height',
  'justifyContent',
  'pill',
  'prominent',
  'size',
  'variant',
  'width',
]);

const NavButtonWrapper = styled(Link).withConfig({
  shouldForwardProp: createShouldForwardStyledProp(nonForwardedProps),
})<NavButtonWrapperProps>`
  text-decoration: none;
  ${({ theme, size, variant, disabled, ghost, dim, prominent, width, height, justifyContent, flex, pill }) =>
    buttonStyle({
      theme,
      size,
      variant,
      disabled,
      ghost,
      prominent,
      dim,
      width,
      height,
      justifyContent,
      flex,
      pill,
    })}
  text-decoration: none;
`;

export const NavButton = styled(
  ({ children, startIcon, endIcon, to, ...props }: NavButtonPropsBase & { to?: LinkProps['to'] }) => (
    <NavButtonWrapper to={props.disabled ? '#' : (to as string)} {...props}>
      {!!startIcon && <Icon icon={startIcon} />}
      {children && <span>{children}</span>}
      {!!endIcon && <Icon icon={endIcon} />}
    </NavButtonWrapper>
  )
)``;
